
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/courses",
      function () {
        return require("private-next-pages/users/[id]/courses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/courses"])
      });
    }
  